// extracted by mini-css-extract-plugin
module.exports = {"verify":"verify___2nC3x","container":"container___jAnND","form":"form___1JTn0"};